import { SubmitAiFeedbackBody } from "@intelligems/ig-types";
import { aiApiClient } from "@src/api/ai-api";
import { useMutation } from "@tanstack/react-query";

const submitFeedback = async (payload: SubmitAiFeedbackBody): Promise<void> => {
  await aiApiClient.post("/feedback", payload);
};

export const useSubmitAiFeedback = () => {
  return useMutation<void, Error, SubmitAiFeedbackBody>({
    mutationFn: submitFeedback,
  });
};
